import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from 'react-query';
import { Dropdown } from 'semantic-ui-react';
import * as API from '../../API';
import './KbCountySelector.scss';
export const KbCountySelector = ({ className, prompt, enabled = true }) => {
    var _a, _b, _c;
    const clsx = [
        'kb-selector',
        'kb-county-selector',
        className !== null && className !== void 0 ? className : ''
    ].join(' ');
    const { data: codeListData } = useQuery('kb/kodeliste', API.fetchCodeList);
    const hashParts = window.location.hash.split('?');
    const searchParams = new URLSearchParams((_a = hashParts[1]) !== null && _a !== void 0 ? _a : '?');
    const currentSelection = (_b = searchParams.get('fylke')) !== null && _b !== void 0 ? _b : '';
    let opts = [];
    opts.push(_jsx(Dropdown.Header, { children: "Fylker" }, "hdr"));
    opts = opts.concat(Object.entries((_c = codeListData === null || codeListData === void 0 ? void 0 : codeListData.fylker) !== null && _c !== void 0 ? _c : {}).map(([fnr, fylkesnavn]) => ({
        key: fnr,
        value: fnr,
        text: _jsx("span", { className: "county", children: fylkesnavn })
    })));
    const onSelectCounty = (e, data) => {
        if (data.value === '') {
            searchParams.delete('fylke');
        }
        else {
            searchParams.set('fylke', data.value);
            searchParams.set('noscroll', '1');
        }
        const q = searchParams.toString();
        window.location.hash = hashParts[0] + (q ? `?${q}` : ``);
    };
    const onClick = (e) => {
    };
    return (_jsx("div", { className: `${clsx}`, title: enabled ? '' : 'Krever abonnement', tabIndex: -1, children: _jsx(Dropdown, { placeholder: prompt !== null && prompt !== void 0 ? prompt : "Filtrer på fylke", fluid: true, disabled: !enabled, selection: true, clearable: true, value: currentSelection, options: opts, onChange: onSelectCounty, onClick: onClick }) }));
};
